import axios from 'axios'
import { Message } from 'element-ui'
import Qs from 'qs'
//import store from '../store/index'
/* 
*请求失败后的错误统一处理
*
*
*/
const errorMsg = (status,other) => {
    //状态码判断
    switch(status){ 
        case 401:
            Message({
                type:'error',
                duration: 0,
                dangerouslyUseHTMLString: true,
                message: '接口调用失败，原因：未登录！！！<a href="/">去登录</a>'
            });
            //window.location.href ='/';
            break;
        case 403:
            Message.error('无权限');
            //toLogin();
            break;
        case 404:
            Message.error('请求的资源不存在');
            break;
        default:
            console.log(other)
    }
}
//设置axios实例
var instance = axios.create({
    transformRequest: [function (data) { 
        //对data进行转换处理
        return Qs.stringify(data)
    }],
    timeout: 30000, //请求超时时间
    withCredentials:true,//跨域请求时是否需要使用凭证
});
//设置post请求头
//instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
/* 
*请求拦截器
*每次请求前。如果存在token责在请求头里携带token
 */
instance.interceptors.request.use(
    config => { 
        //登录流程控制中，根据本地是否存在token判断用户的登录情况
        //即使存在token，也可能过期了，所以每次请求的时候带上token
        //后台根据携带的token判断用户的登录情况，并返回对应的状态码
        //而后我们可以在响应拦截器中，根据状态码进行一些统一的操作
//        const token = store.state.token;
 //       token && (config.headers.Authorization);
        return config;
    },
    error => Promise.error(error)
)
//响应拦截器
instance.interceptors.response.use(
    //请求成功
    res => res.status === 200 ? Promise.resolve(res) : Promise.reject(res),
    //请求失败
    error => { 
        const { response } = error;
        if (response) {
            //请求已发出，但是不在2**的范围
            errorMsg(response.status, response.data.message)
            return Promise.reject(response);
        } else { 
            //处理断网的情况
            //eg:请求超时或断网时，更新state的network状态
            //network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
            //关于断网组件中的刷新重新获取数据，会在断网组件中说明
 //           store.commit('changeNetwork',false)
        }
    }
)
export default instance;